import React, { Fragment, useState, useEffect } from "react";
import { DropdownToggle, DropdownMenu, DropdownItem, Dropdown } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchGetAccounts } from "../../services/api/accounts";
import { getPersonInfo } from "../../services/api/person";
import { getCurrentAccount, getSavedPersonInfo } from "../../reducers/selectors";
import { currentAccountSet, personInfoSet } from "../../actions/entities";
import arrow from "../../../public/svg/keyboard_arrow_down.svg";
import style from "./UserSelector.scss";

export const UserSelector = ({ isInNavbar }) => {
  const [loadingInfo, setLoadingInfo] = useState(true);
  const [accounts, setAccounts] = useState([]);
  const dispatch = useDispatch();
  const [userDropdownIsOpen, setUserDropdownIsOpen] = useState(false);
  const currentAccount = useSelector(getCurrentAccount);
  const personInfo = useSelector(getSavedPersonInfo);
  const [myData, setMyData] = useState(false);
  const [investorProfile, setInvestorProfile] = useState(false);

  const profileRiskString = {
    Conservative: "Conservador",
    Moderate: "Moderado",
    Aggressive: "Agresivo",
  };

  const hideMobile = () => {
    if (document.body.classList.contains("sidebar-mobile-show")) {
      document.body.classList.toggle("sidebar-mobile-show");
    }
  };

  useEffect(() => {
    getPersonInfo()
      .then(({ response }) => {
        dispatch(personInfoSet(response.personInfo));
      })
      .catch((err) => console.error(err))
      .finally(() => setLoadingInfo(false));
  }, []);

  useEffect(() => {
    fetchGetAccounts()
      .then((r) => {
        if (r.response.accounts.length > 0) {
          setAccounts(r.response.accounts);
          handleChangeAccount(r.response.accounts[0]);
        } else {
          handleChangeAccount({
            noAccounts: true,
            AccountNumber: 0,
            AccountEmail: "",
            AccountName: "",
            advisorName: "",
            advisorFirstLastName: "",
            advisorEmail: "",
            advisorPhone: "",
          });
        }
      })
      .catch((err) => console.error(err));
  }, []);

  const toggleUserDropdown = () => {
    setUserDropdownIsOpen((prevState) => !prevState);
  };

  const handleChangeAccount = (newAccount) => {
    dispatch(currentAccountSet({ ...currentAccount, ...newAccount, AccountNumber: newAccount.number }));
  };

  const userSelectorData = () => {
    return (
      <Fragment>
        {accounts.map((account, index) => (
          <DropdownItem
            className={style.accountItem}
            key={index}
            onClick={() => {
              handleChangeAccount(account);
              toggleUserDropdown();
            }}
          >
            Cambiar a cuenta {account.number}
          </DropdownItem>
        ))}
        <Link className={style.link} to="/myData">
          <DropdownItem
            className={myData ? style.activeItem : style.inactiveItem}
            onClick={() => {
              setUserDropdownIsOpen(false);
              setMyData(true);
              setInvestorProfile(false);
              hideMobile();
            }}
          >
            Mis datos
          </DropdownItem>
        </Link>
        <Link className={style.link} to="/investorProfile">
          <DropdownItem
            className={investorProfile ? style.activeItem : style.inactiveItem}
            onClick={() => {
              setUserDropdownIsOpen(false);
              setInvestorProfile(true);
              setMyData(false);
              hideMobile();
            }}
          >
            Perfil inversor
          </DropdownItem>
        </Link>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <span className={style.container}>
        <span className={style.rightContainer}>
          {personInfo && (
            <span
              className={style.accountHolderName}
            >{`${personInfo.PhysicalPersonFirstName} ${personInfo.PhysicalPersonFirstLastName}`}</span>
          )}
          <span className={style.secondRow}>
            <span className={style.secondRowContainer}>
              <Dropdown
                isOpen={userDropdownIsOpen}
                toggle={toggleUserDropdown}
                nav
                inNavbar
                className={style.dropdown}
                tag="ul"
              >
                <DropdownToggle nav caret className={style.userSelector}>
                  <DropdownMenu className={style.dropDownMenu}>{userSelectorData()}</DropdownMenu>
                </DropdownToggle>
              </Dropdown>
              <p className={style.accountNumber}>cuenta {currentAccount.AccountNumber}</p>
              <img
                src={arrow}
                className={userDropdownIsOpen ? style.arrowImgActive : style.arrowImg}
                onClick={() => {
                  setUserDropdownIsOpen(!userDropdownIsOpen);
                }}
              />
            </span>
          </span>
          <div className={style.blueTextContainer}>
            <div className={style.investor}>
              perfil inversor <b>{profileRiskString[currentAccount.accountProfileRisk]}</b>
            </div>
            <div
              className={style.assesor}
            >{`asesor ${currentAccount.advisorName} ${currentAccount.advisorFirstLastName} / celular ${currentAccount.advisorPhone}`}</div>
          </div>
        </span>
      </span>
    </Fragment>
  );
};
